import { APP_BASE_PATH } from '@/config/app'
import { normalizeLocale } from '@/utils/lang'

export function getGoodsRechargeUrl (locale) {
  const lang = normalizeLocale(locale) == 1 ? 'zh_CN' : 'en'
  if (typeof window === 'undefined') {
    return `/goods/${lang}/`
  }
  return `${window.location.origin}/goods/?lang=${lang}`
}

export function appUrl (hashPath, query = '') {
  const path = hashPath.startsWith('/') ? hashPath : `/${hashPath}`
  const suffix = query ? (query.startsWith('?') ? query : `?${query}`) : ''
  return `${APP_BASE_PATH}#${path}${suffix}`
}



// WEBPACK FOOTER //
// ./src/utils/appUrl.js